import React from "react";

import { cn } from "@/lib/utils";

interface CardLabelProps {
  label: string;
  className?: string;
}

interface CardHeaderLabelProps {
  label: string;
  className?: string;
  children?: React.ReactNode;
}

// The label text itself - for use when custom wrapper is needed
export const CardLabel = ({ label, className }: CardLabelProps) => (
  <span className={cn("text-lg font-semibold leading-none", className)}>{label}</span>
);

// Standardized header container with consistent positioning
const CardHeaderLabel = ({ label, className, children }: CardHeaderLabelProps) => {
  return (
    <div className="flex min-h-[56px] items-center justify-between gap-3 px-4 pt-4">
      <CardLabel label={label} className={className} />
      {children && (
        <div className="flex flex-wrap items-center justify-end gap-2">{children}</div>
      )}
    </div>
  );
};

export default CardHeaderLabel;
